<script setup lang="ts">
import PocketIncidents from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/PocketIncidents.vue'

import BetButtons from './BetButtons/BetButtons.vue'
</script>

<template>
  <PocketIncidents>
    <template #betButtons>
      <BetButtons />
    </template>
  </PocketIncidents>
</template>
